import * as propertyTypes from "../../property_types"

class UniqueQuestionIdProperty extends propertyTypes.TextPropertyBase {

    constructor(valueField: string, label: string) {
        super("UNIQUEQUESTIONNAME", valueField, label);
    }
}

export abstract class ServiceReportComponentBaseProps extends propertyTypes.Serializable {
    private questionIdMetadata = new propertyTypes.TextProperty("QuestionId", "Question id", true)
        .SetReadonly(true);
    public QuestionId: string;

    private translatableOverriddenTextMetadata = new propertyTypes.TranslatableTextArrayProperty("TranslatableOverriddenText", "Override question text", "Language", "Translation");
    public TranslatableOverriddenText: string;

    private translatableRemarkMetadata = new propertyTypes.TranslatableTextArrayProperty("TranslatableOverriddenRemark", "Override remark", "Language", "Translation");
    public TranslatableRemark: string;

    private UniqueNameMetadata = new UniqueQuestionIdProperty("Id", "Unique name");
    public UniqueName: string;

    private VisibilityPredicateMetadata = new propertyTypes.TextPropertyBase("CR_SCRIPT_EDITOR", "VisibilityPredicate", "Visibility script");
    public VisibilityPredicate: string;

    private sizeMetadata = new propertyTypes.TextProperty("Size", "Size", true);
    public Size: string;

    private rowSizeMetadata = new propertyTypes.TextProperty("RowSize", "Row size", true);
    public RowSize: string;

    private breakAfterMetadata = new propertyTypes.CheckBoxProperty("BreakAfter", "Break after");
    public BreakAfter: string;

    private AllowDocumentsMetadata = new propertyTypes.CheckBoxProperty("AllowDocuments", "Allow documents");
    public AllowDocuments: string;

    private DefaultValueMetadata = new propertyTypes.TextProperty("DefaultValue", "Default value");
    public DefaultValue: string;

    private baseComponentMetadata: propertyTypes.BaseProperty[];

    constructor() {
        super();
        this.baseComponentMetadata = [this.questionIdMetadata, this.UniqueNameMetadata, this.AllowDocumentsMetadata, this.VisibilityPredicateMetadata, this.sizeMetadata, this.rowSizeMetadata, this.breakAfterMetadata, this.translatableOverriddenTextMetadata, this.translatableRemarkMetadata, this.DefaultValueMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.baseComponentMetadata;
    };

    hasErrors(): boolean {
        const meta = this.getMetadata();

        for (let x of meta) {
            let value = this[x.ValueField];

            if (x.IsMandatory && !value) {
                return true;
            }
        }
        return false;
    }
};